import React, { useEffect, useState } from "react";
import { Dropdown, Card, Table, Badge, Col, Spinner } from "react-bootstrap";
import ListIcon from "../../../images/list.png";
import PageTitle from "../../layouts/PageTitle";
import toast from "react-hot-toast";
import Lottie from "lottie-react";
import animationData from "../../../images/loding.json";
import moment from "moment";
import { useNavigate } from "react-router-dom";
// import {
//   appConfigApi,
//   addConfigApi,
//   deleteAppConfigApi,
//   subComponentToggleApi,
// } from "../../components/APIs/Api";
// import AddConfig from "../../modal/AddConfig";

export default function AppConfig() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [addConfigModal, setAddConfigModal] = useState(false);

  async function configListData() {
    setLoader(true);
    try {
      const res = await fetch("");
      setData(res);
      setLoader(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoader(false);
    }
  }

  async function handleDeleteComponent(id) {
    setLoader(true);
    try {
      const res = await fetch("");
      configListData();
      setLoader(false);
      toast.success("Component deleted successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setLoader(false);
    }
  }

  useEffect(() => {
    configListData();
  }, []);

  return (
    <div>
      <PageTitle
        activeMenu="Category"
        motherMenu="List"
        isButton={false}
        action={setAddConfigModal}
      />

      <Col className="pr-0">
        {loader ? (
          <div>
            <Lottie
              style={{
                height: "200px",
                marginTop: "45px",
                padding: "30px",
              }}
              animationData={animationData}
            />
          </div>
        ) : (
          <Card>
            <Card.Body>
              <Table>
                <thead style={{ color: "black", textAlign: "center" }}>
                  <tr>
                    <th>
                      <strong>S.NO</strong>
                    </th>
                    <th>
                      <strong>Category</strong>
                    </th>
                    <th>
                      <strong>View List</strong>
                    </th>
                  </tr>
                </thead>
                <tbody style={{ textAlign: "center" }}>
                  {["Job", "Service"]?.map((item, i) => (
                    <tr
                      key={item._id}
                      className={i % 2 === 0 ? "even-row" : ""}
                    >
                      <td>{i + 1}</td>
                      <td>{item}</td>

                      <td>
                        <div className="d-flex align-items-center justify-content-center">
                          <div
                            className="ml-1"
                            onClick={() =>
                              navigate("/category-config", {
                                state: {
                                  item: item,
                                },
                              })
                            }
                          >
                            <img
                              src={ListIcon}
                              alt="icon"
                              className="view-list-icon"
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {data?.data?.data?.components?.length === 0 && (
                <div className="justify-content-center d-flex my-5 ">
                  Sorry, Data Not Found!
                </div>
              )}
            </Card.Body>
          </Card>
        )}
      </Col>
      {/* {addConfigModal && (
        <AddConfig
          show={addConfigModal}
          onHide={() => setAddConfigModal(false)}
          title={"Add Component"}
          buttonTitle={"Add"}
          api={addConfigApi}
          refresh={configListData}
        />
      )} */}
    </div>
  );
}
